import React from 'react'
import TrailerPopup from './TrailerPopup'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import { FRONT, PROGRAM_WEISCHERADS, TRANSLATION, UI_TRAILER } from '../constants/state'
import { setTrailerMovie } from '../actions'
import getData from '../functions/getData'
import { WEISCHER_PREROLL } from '../constants/weischerTypes'
import { filterWeischerAds, getPrerolUrl } from '../functions/weischerHelpers'
import { CustomPopupWrapper } from '../General/SiteSlidebars'

const mapDispatchToProps = (dispatch, ownProps) => ({
    setTrailerMovie: (e) => {
        if('force' === e || (e && e.target && e.target.classList.contains('has-popup-close'))) {
            dispatch(setTrailerMovie(null))
        }
    }
})

const mapStateToProps = (state, ownProps) => ({
    trailerMovie: getData(state, [UI_TRAILER, 'trailerMovie']),
    weischerAds: getData(state, PROGRAM_WEISCHERADS),
    translation: getData(state, TRANSLATION),
    cinemaDataFront: getData(state, FRONT)
})

const TrailerPopupWrapper = ({trailerMovie, weischerAds, setTrailerMovie, cinemaDataFront, translation}) => {
    if(!trailerMovie) {
        return ''
    }

    const filteredWeischerAds = filterWeischerAds(weischerAds, [WEISCHER_PREROLL])
    const prerollUrl = getPrerolUrl(filteredWeischerAds[WEISCHER_PREROLL])
    const {set_netural_colors_for_fsk} = cinemaDataFront
    const {trailerUrl, fsk} = trailerMovie

    return ( 
        trailerUrl && <CustomPopupWrapper>
            <TrailerPopup 
                trailerURL={trailerUrl}
                prerollUrl={prerollUrl}
                fsk={fsk}
                setNeturalColorsForFsk={set_netural_colors_for_fsk}
                displayPopup={true}
                addClassToPopup="popup-content-small"
                closePopup={setTrailerMovie}
                translation={translation}
            />
            </CustomPopupWrapper>
    )
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(TrailerPopupWrapper)


